import { render, staticRenderFns } from "./LoginIdp.vue?vue&type=template&id=4062af9c&scoped=true&"
import script from "./LoginIdp.vue?vue&type=script&lang=ts&"
export * from "./LoginIdp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4062af9c",
  null
  
)

export default component.exports